import { financialIdempotencyInterceptor } from './interceptors/financial-idempotency.interceptor';
import { councilWebSessionInterceptor } from './interceptors/council-web-session.interceptor';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { crcViewScopeInterceptor } from './interceptors/crc-view-scope.interceptor';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';
import { provideServiceWorker } from '@angular/service-worker';

const KaparkingPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#eef0ff',
      100: '#dce1ff',
      200: '#bdc6ff',
      300: '#9aa7ff',
      400: '#7888ff',
      500: '#6576ff',
      600: '#5262d9',
      700: '#414eb0',
      800: '#343f8d',
      900: '#2c356f',
      950: '#1a1f43',
    },
    formField: {
      borderRadius: '4px',
      paddingX: '0.75rem',
      paddingY: '0.5rem',
      focusRing: {
        width: '3px',
        style: 'solid',
        color: 'rgba(101, 118, 255, 0.12)',
        offset: '0',
        shadow: 'none',
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, councilWebSessionInterceptor, crcViewScopeInterceptor, financialIdempotencyInterceptor])
    ),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: KaparkingPreset,
        options: {
          darkModeSelector: 'none',
        },
      },
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
};
